/**
 * What counts as "page not found" in the app, in one place (AVA-697 D10). The router's catch-all
 * route, the Analysis page (whose bare path has no tab) and the assistant's ui.navigate all read it,
 * so the assistant never reports "opened" for a page the user would see as not found.
 * No Vue or path-alias imports, so `npm run test:unit` (node --test) can load it directly.
 */

/** Name of the catch-all route that shows the not-found page. */
export const NOT_FOUND_ROUTE_NAME = 'not-found';

/**
 * Route meta flag for a parent route that is only a frame for its children: its own path, with no
 * child matched, is not a page.
 */
export const META_NEEDS_CHILD = 'needsChild';

/**
 * @param {{ name?: string|null, matched?: Array<{ meta?: object }> }|null|undefined} route a resolved route
 * @returns {boolean} the route shows no page: unknown, the catch-all, or a parent frame without a child
 */
export function isNotFoundRoute(route) {
  if (!route || !Array.isArray(route.matched) || route.matched.length === 0) return true;
  if (route.name === NOT_FOUND_ROUTE_NAME) return true;
  const deepest = route.matched[route.matched.length - 1];
  return Boolean(deepest && deepest.meta && deepest.meta[META_NEEDS_CHILD]);
}
